import type { SerpHotelPositionsTracking } from '../model/serpHotelPositions';
import type { TrackingData } from '../model/types';

export function getSerpHotelPositionsData({
  searchUuid,
  filteredSearchUuid,
  sortType,
  hotels,
  selectedHotelId,
}: SerpHotelPositionsTracking): TrackingData {
  const selectedIndex = hotels.findIndex(({ id }) => id === selectedHotelId);

  return {
    searchUuid,
    filteredSearchUuid,
    sortType,
    hotels: hotels.slice(0, selectedIndex + 1).map(({ id, price }, index) => ({
      id,
      price,
      position: index + 1,
      click: id === selectedHotelId ? 1 : 0,
    })),
  };
}
